import "./Header.scss";
import { headerLogo } from "../../service/image";
import ContactBtn from "../ContactBtn/ContactBtn";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = ({ setOpenModal }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("no-scroll");

    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isMenuOpen]);



  return (
    <header id="header" className={isMenuOpen ? "open" : ""}>
      <div className="container">
        <div className="header__items">
          <button className="header__burger-btn" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className="header__logo">
            <a href="/">
              <img src={headerLogo} alt="Header logo" />
            </a>
          </div>

          <nav>
            <div className="row">
            <a href="/" onClick={closeMenu}>
                Home
              </a>
              <Link to="/portfolio" onClick={closeMenu}>
                Portfolio
              </Link>

              <Link to="/about-me" onClick={closeMenu}>
                About me
              </Link>
              <Link to="/blog" onClick={closeMenu}>
                Blog
              </Link>

              <ContactBtn setOpenModal={() => { setOpenModal(true); closeMenu(); }} />
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header


